import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {WHITE} from 'ui-library/Colors';
import UIPlaceholder from 'ui-library/UIPlaceholder';

const SURROUNDING_GRAY_BAND_WIDTH = 20;

interface BaseStepStatusViewProps {
  children: ReactNode;
}

/**
 * Component to show a status message for a step that covers the entire view.
 *
 * The status's ui should be specified as the `children`.
 *
 * @package
 */
export default function BaseStepStatusView({children}: BaseStepStatusViewProps): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <UIPlaceholder infoSection={children} />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    margin: SURROUNDING_GRAY_BAND_WIDTH,
    height: `calc(100% - ${2 * SURROUNDING_GRAY_BAND_WIDTH}px)`,
    width: `calc(100% - ${2 * SURROUNDING_GRAY_BAND_WIDTH}px)`,
    backgroundColor: WHITE,
  },
  loadingImage: {
    width: 100,
    height: 100,
  },
});
